export default "__VITE_ASSET__BupC4Cq8__"